import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Zoom, buttonClasses } from '@mui/material';
import { ThemeOptions } from '@mui/material/styles';

const DefaultThemeOptions: ThemeOptions = {
    typography: {
        h1: {
            fontSize: '3rem'
        },
        h2: {
            fontSize: '1.5rem'
        },
        h3: {
            fontSize: '1.25rem'
        },
        h4: {
            fontSize: '1.20rem'
        },
        h5: {
            fontSize: '1.15rem'
        },
        h6: {
            fontSize: '1.10rem'
        }
    },
    components: {
        MuiAlert: {
            defaultProps: {
                iconMapping: {
                    error: <FontAwesomeIcon icon={faExclamationCircle} />,
                    warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
                    success: <FontAwesomeIcon icon={faCheckCircle} />,
                    info: <FontAwesomeIcon icon={faInfoCircle} />
                }
            },
            styleOverrides: {
                icon: {
                    fontSize: '1.5rem'
                },
                action: {
                    [`& .${buttonClasses.root}`]: {
                        minWidth: 0
                    },
                    [`& .${buttonClasses.startIcon} svg`]: {
                        fontSize: '1.5rem'
                    }
                }
            }
        },
        MuiTooltip: {
            defaultProps: {
                TransitionComponent: Zoom
            }
        }
    }
};

export default DefaultThemeOptions;